<template>
  <div id="search-results" class="section">
    <RefinementList></RefinementList>
    <div class="section" v-if="page !== 1">
      <a
        class="button is-info is-outlined is-fullwidth has-text-centered"
        @click="$emit('loadless')"
      >View Previous Results</a>
    </div>
    <ais-results :results-per-page="30">
      <template slot-scope="{ index, result }">
        <a
          :href="$store.state.listing_ad_link"
          v-if="$store.state.listing_ad_image && $store.state.listing_ad_link"
        >
          <img
            v-if="index === 3"
            :src="$store.state.listing_ad_image"
            class="is-block is-block-centered is-ad"
            alt="Advertisement"
          >
        </a>
        <router-link
          :to="{ name: 'record', params: { record: result.slug }}"
          :class="`media section ${ result.sponsor ? 'is-featured' : '' }`"
          :id="result.id"
          @mouseover.native.self="$emit('highlight', $event.target.id)"
          @mouseleave.native.self="$emit('dehighlight', $event.target.id)"
          :aria-label="result.name"
        >
          <div class="featured-icon" v-if="result.sponsor">FEATURED</div>
          <div
            class="has-background-danger featured-icon"
            v-if="expert.enabled && result.expert"
          >
            EXPERT
          </div>
          <figure class="media-left" v-if="result.image_uri && result.sponsor">
            <p class="image is-128x128">
              <img :src="result.image_uri" :alt="result.name">
            </p>
          </figure>
          <div class="media-content">
            <h4 class="title is-size-4">
              <ais-highlight :result="result" attribute-name="name"></ais-highlight>
            </h4>
            <span class="subtitle is-7 is-block has-text-weight-bold has-text-grey">
              <span v-if="result.locations.length > 0 && result.locations[0].city">
                {{ result.locations[0].city.toUpperCase() }}
              </span>
              <span v-if="result[currentDirectory.secondary_search_data_point]">
                <fa icon="chevron-right" class="fa-fw"></fa>
                {{ secondaryDataPoint(result[currentDirectory.secondary_search_data_point]) }}
              </span>
            </span>
            <template v-if="result.sponsor">
              <span
                class="result-phone has-text-grey-dark is-together"
                v-if="result.locations.length > 0 && result.locations[0].phone"
              >
                <fa icon="phone"></fa> {{ result.locations[0].phone }}
              </span>
              <span class="has-text-grey-dark is-together" v-if="result.profile_uri">
                <fa icon="globe"></fa> {{ website(result.profile_uri) }}
              </span>
            </template>
          </div>
        </router-link>
      </template>
    </ais-results>
    <div class="section" v-if="this.searchStore.results.length == 0">
      <h2 class="title has-text-centered">0 results</h2>
    </div>
    <div class="section">
      <a
        class="button is-info is-outlined is-fullwidth has-text-centered"
        v-if="this.searchStore.results.length === this.searchStore.resultsPerPage"
        @click="$emit('lazyload')"
      >Load More Results</a>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved */
import RefinementList from '@/components/RefinementList.vue';
import { Component } from 'vue-instantsearch';

export default {
  mixins: [Component],
  props: {
    page: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      refinements: [],
    };
  },
  computed: {
    query() { return this.searchStore.query; },
    facetFilters() { return this.searchStore.activeRefinements.filter(r => r.type === 'facet'); },
    currentDirectory() {
      return this.$store.state.directories[this.$route.params.directory.toLowerCase()];
    },
    expert() { return this.$store.state.expert; },
  },
  methods: {
    secondaryDataPoint(dataPoint) {
      if (Array.isArray(dataPoint)) {
        return dataPoint[0].toUpperCase();
      } else if (typeof dataPoint === 'string') {
        return dataPoint.toUpperCase();
      }
      return '';
    },
    website(uri) {
      let hostname;
      /* eslint-disable prefer-destructuring */
      if (uri.indexOf('//') > -1) {
        hostname = uri.split('/')[2];
      } else {
        hostname = uri.split('/')[0];
      }
      hostname = hostname.split('?')[0];
      return hostname;
    },
  },
  watch: {
    query() {
      this.$emit('resetPageCount');
    },
    facetFilters() {
      if (this.facetFilters.length > 0
        && JSON.stringify(this.facetFilters) !== JSON.stringify(this.refinements)) {
        this.$emit('resetPageCount');
        this.refinements = this.facetFilters;
      }
    },
  },
  components: {
    RefinementList,
  },
};
</script>
